import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PolylineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"polyline"}/>
}
